export function isIdDefined(id) {
    return !((id === "undefined") || (id == null))
}